// extracted by mini-css-extract-plugin
export var label = "_c9-1";
export var reminder = "_c9-0";